const VodkaMass=[
    // {
    //     id:1,
    //     title:"Absolut (Швеція) 0,5л",
    //     price:"650 грн",
    //     src: require('../img/absolut.webp'),
    //     text:"50мл - 65грн",
    // },
    // {
    //     id:2,
    //     title:"Nemiroff Lex (Україна) 0,5л",
    //     price:"600 грн",
    //     src: require('../img/lex.webp'),
    //     text:"50мл - 60грн",
    // },
    // {
    //     id:3,
    //     title:"Nemiroff Original (Україна) 0,5л",
    //     price:"380 грн",
    //     src: require('../img/nemiroff.webp'),
    //     text:"50мл - 38грн",
    // },
    {
        id:9,
        title:"Горілка Стерлінг (Шотландія) 1л",
        price:"1600 грн",
        src: require('../img/sterling.png'),
        text:"50мл - 80 грн",
    },
    {
        id:4,
        title:"Коскенкорва (Фінляндія) 0,5л",
        price:"1000 грн",
        src: require('../img/kosk.png'),
        text:"50мл - 100 грн",
    },
    //{
        //id:5,
        //title:"Коскенкорва імбир (Фінляндія) 0,5л",
        //price:"700 грн",
        //src: require('../img/kosk.png'),
        //text:"50мл - 70 грн",
   // },
    //{
        //id:6,
        //title:"Смірнофф Ред №21 (Великобританія) 0,5л",
        //price:"620 грн",
        //src: require('../img/smirnoff.png'),
        //text:"50мл - 62 грн",
    //},
    {
        id:7,
        title:"Перша Гільдія Поважна (Україна) 0,5л",
        price:"550 грн",
        src: require('../img/persha.png'),
        text:"50мл - 55 грн",
    },
    {
        id:8,
        title:"Горілка рада преміум (Україна) 0,7л",
        price:"924 грн",
        src: require('../img/rada.png'),
        text:"50мл - 66 грн",
    },
]

export default VodkaMass;